import { Injectable } from '@angular/core';
import { MODULE_CONSTANTS, MODULE_GROUP_CONSTANTS, ROLE_CONSTANTS, SIDEBAR_MENU_VISIBILITY_CHECK_CONSTANTS } from '../constants/constant';
import { RouteInfo } from 'src/app/layout/sidebar/sidebar.metadata';

@Injectable({
  providedIn: 'root'
})
export class SidebarMenuService {
  constructor() {
    //
  }
  getSidebarRoutesData(): RouteInfo[] {
    return [
      {
        path: '/dashboard',
        title: 'MENUITEMS.DASHBOARD',
        iconType: 'feather',
        icon: 'Menu',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_CONSTANTS.DASHBOARD],
        groupKey: [MODULE_GROUP_CONSTANTS.DASHBOARD],
        // roleAccess:[ROLE_CONSTANTS.ADMIN, ROLE_CONSTANTS.CITY_MANAGER,
        //   ROLE_CONSTANTS.ASSISTANT_CITY_MANAGER, ROLE_CONSTANTS.ACCOUNT_SUERVISOR, ROLE_CONSTANTS.ACCOUNT_MANAGER,
        //   ROLE_CONSTANTS.ACCOUNT_EXECUTIVE, ROLE_CONSTANTS.CLIENT, ROLE_CONSTANTS.PAYROLL_FINANCE, ROLE_CONSTANTS.SO_ESTIMATOR,
        //   ROLE_CONSTANTS.ACCOUNTING, ROLE_CONSTANTS.ACCOUNT_COORDINATOR, ROLE_CONSTANTS.USER_ROLE_DL, ROLE_CONSTANTS.ASSISTANT_MANAGER,
        //   ],
        checkOtherForVisibility: [],
        submenu: [

        ]
      },
      {
        path: '',
        title: 'MENUITEMS.ADMIN',
        iconType: 'feather',
        icon: 'monitor',
        class: 'menu-toggle',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_GROUP_CONSTANTS.ADMIN],
        groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
        //roleAccess:[ROLE_CONSTANTS.ADMIN, ROLE_CONSTANTS.ACCOUNT_SUERVISOR, ROLE_CONSTANTS.ACCOUNT_COORDINATOR],
        checkOtherForVisibility: [],
        submenu: [
          {
            path: '/admin/application-updates',
            title: 'MENUITEMS.ADMIN_SUB_MENU.APPLICATION_UPDATES',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.APPLICATION_UPDATE],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/city',
            title: 'MENUITEMS.ADMIN_SUB_MENU.CITY',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.CITY_MANAGEMENT],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            //  roleAccess:[ROLE_CONSTANTS.ADMIN, ROLE_CONSTANTS.ACCOUNT_SUERVISOR],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/client',
            title: 'MENUITEMS.ADMIN_SUB_MENU.CLIENT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.CLIENT_MANAGEMENT],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/client-contact-role',
            title: 'MENUITEMS.ADMIN_SUB_MENU.CLIENT_CONTACT_ROLE',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.CLIENT_CONTACT_ROLE],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/client-rate-cards',
            title: 'MENUITEMS.ADMIN_SUB_MENU.CLIENT_RATE_CARD',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.CLIENT_RATE_CARD],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/general-city',
            title: 'MENUITEMS.ADMIN_SUB_MENU.GENERAL_CITY',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.GENERAL_CITY_MANAGEMENT],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            //roleAccess:[ROLE_CONSTANTS.ADMIN, ROLE_CONSTANTS.ACCOUNT_SUERVISOR],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/holiday',
            title: 'MENUITEMS.ADMIN_SUB_MENU.HOLIDAY_MANAGEMENT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.HOLIDAY_MANAGEMENT],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/labors',
            title: 'MENUITEMS.ADMIN_SUB_MENU.LABOR',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.LABOR_MANAGEMENT],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/labor-tax-rule-wages',
            title: 'MENUITEMS.ADMIN_SUB_MENU.LABOR_TAX_RULE_WAGES',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.LABOR_TAX_RULE_WAGES_MANAGEMENT],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/landing-page',
            title: 'MENUITEMS.ADMIN_SUB_MENU.LANDING_PAGE',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.LANDING_PAGE_CUSTOMIZATION],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/manage-city-manager',
            title: 'MENUITEMS.ADMIN_SUB_MENU.MANAGE_CITY_MANAGER',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.MANAGE_CITY],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            //roleAccess:[ROLE_CONSTANTS.ADMIN, ROLE_CONSTANTS.CITY_MANAGER, ROLE_CONSTANTS.SO_ESTIMATOR],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/material',
            title: 'MENUITEMS.ADMIN_SUB_MENU.MATERIAL',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.MATERIAL_MANAGEMENT],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            //roleAccess:[ROLE_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/platinum-instruction-template',
            title: 'MENUITEMS.ADMIN_SUB_MENU.PLATINUM_INSTRUCTION_TEMPLATE',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.PLATINUM_INSTRUCTION_TEMPLATE],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/states',
            title: 'MENUITEMS.ADMIN_SUB_MENU.STATES',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            //roleAccess:[ROLE_CONSTANTS.ADMIN],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            moduleKey: [MODULE_CONSTANTS.STATE_MANAGEMENT],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/system-role',
            title: 'MENUITEMS.ADMIN_SUB_MENU.SYSTEM_ROLE',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            //roleAccess:[ROLE_CONSTANTS.ADMIN],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            moduleKey: [MODULE_CONSTANTS.SYSTEM_ROLE],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/tradeshow',
            title: 'MENUITEMS.ADMIN_SUB_MENU.TRADE_SHOW',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.TRADE_SHOW],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/users',
            title: 'MENUITEMS.ADMIN_SUB_MENU.USERS',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            moduleKey: [MODULE_CONSTANTS.USER_MANAGEMENT],
            // roleAccess:[ROLE_CONSTANTS.ADMIN],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/admin/venue',
            title: 'MENUITEMS.ADMIN_SUB_MENU.VENUE',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.VENUE_MANAGEMENT],
            groupKey: [MODULE_GROUP_CONSTANTS.ADMIN],
            //roleAccess:[ROLE_CONSTANTS.ADMIN, ROLE_CONSTANTS.ACCOUNT_SUERVISOR, ROLE_CONSTANTS.ACCOUNT_COORDINATOR],
            checkOtherForVisibility: [],
            submenu: [],
          }
        ]
      },
      {
        path: '/so/list',
        title: 'MENUITEMS.SERVICE_ORDER',
        iconType: 'feather',
        icon: 'Menu',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_CONSTANTS.SERVICE_ORDER],
        groupKey: [MODULE_GROUP_CONSTANTS.SERVICE_ORDER],
        checkOtherForVisibility: [],
        submenu: [

        ]
      },
      {
        path: '',
        title: 'MENUITEMS.ACCOUNTING',
        iconType: 'feather',
        icon: 'dollar-sign',
        class: 'menu-toggle',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_GROUP_CONSTANTS.ACCOUNTING],
        groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNTING],
        checkOtherForVisibility: [],
        submenu: [
          {
            path: '/dashboard-accounting',
            title: 'MENUITEMS.ACCOUTING_SUB_MENU.ACCOUNTING_DASHBOARD',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.ACCOUNTING_DASHBOARD],
            groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNTING],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/accounting/deposit-invoice-report',
            title: 'MENUITEMS.ACCOUTING_SUB_MENU.ACCOUNTING_DEPOSIT_INVOICE_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.ACCOUNTING_DEPOSIT_INVOICE_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNTING],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/accounting/payroll-billed-hrs-report',
            title: 'MENUITEMS.ACCOUTING_SUB_MENU.ACCOUNTING_PAYROLL_BILLED_HRS_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.ACCOUNTING_PAYROLL_BILLED_HRS_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNTING],
            checkOtherForVisibility: [],
            submenu: [],
          },
        ]
      },
      {
        path: '',
        title: 'MENUITEMS.ACCOUNT_MANAGER',
        iconType: 'feather',
        icon: 'dollar-sign',
        class: 'menu-toggle',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_GROUP_CONSTANTS.ACCOUNT_MANAGER],
        groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNT_MANAGER],
        checkOtherForVisibility: [],
        submenu: [
          {
            path: '/account-manager/estimate-follow-up-report',
            title: 'MENUITEMS.ACCOUNT_MANAGER_SUB_MENU.ACCOUNT_MANAGER_ESTIMATE_FOLLOW_UP_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.ESTIMATE_FOLLOW_UP_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNT_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/account-manager/follow-up-90-60-30-report-v2',
            title: 'MENUITEMS.ACCOUNT_MANAGER_SUB_MENU.ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.FOLLOW_UP_90_60_30_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNT_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/account-manager/platinum-report',
            title: 'MENUITEMS.ACCOUNT_MANAGER_SUB_MENU.ACCOUNT_MANAGER_PLATINUM_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.PLATINUM_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNT_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/account-manager/platinum-instruction-due',
            title: 'MENUITEMS.ACCOUNT_MANAGER_SUB_MENU.ACCOUNT_MANAGER_PLATINUM_INSTRUCTION_DUE_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.PLATINUM_INSTRUCTION_DUE],
            groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNT_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
        ]
      },
      {
        path: '',
        title: 'MENUITEMS.ACCOUNT_SUPERVISOR',
        iconType: 'feather',
        icon: 'dollar-sign',
        class: 'menu-toggle',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_GROUP_CONSTANTS.ACCOUNT_SUPERVISOR],
        groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNT_SUPERVISOR],
        checkOtherForVisibility: [],
        submenu: [
          {
            path: '/account-supervisor/order-and-outstanding-estimates',
            title: 'MENUITEMS.ACCOUNT_SUPERVISOR_SUB_MENU.ORDER_AND_OUTSTANDING_ESTIMATE',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.MONITORING_PROGRESS],
            groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNT_SUPERVISOR],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/account-supervisor/platinum-report-count',
            title: 'MENUITEMS.ACCOUNT_SUPERVISOR_SUB_MENU.PLATINUM_REPORT_COUNT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.MONITORING_PROGRESS],
            groupKey: [MODULE_GROUP_CONSTANTS.ACCOUNT_SUPERVISOR],
            checkOtherForVisibility: [],
            submenu: [],
          },
        ]
      },
      {
        path: '',
        title: 'MENUITEMS.EMAIL_VIEWER',
        iconType: 'feather',
        icon: 'book-open',
        class: 'menu-toggle',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_GROUP_CONSTANTS.EMAIL_VIEWER],
        groupKey: [MODULE_GROUP_CONSTANTS.EMAIL_VIEWER],
        checkOtherForVisibility: [],
        submenu: [
          {
            path: '/email-viewer/list/normal',
            title: 'MENUITEMS.EMAIL_VIEWER_SUB_MENU.EMAIL_LIST',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.EMAIL_LIST],
            groupKey: [MODULE_GROUP_CONSTANTS.EMAIL_VIEWER],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/email-viewer/qb-list/quickbook',
            title: 'MENUITEMS.EMAIL_VIEWER_SUB_MENU.QUICKBOOK_EMAIL',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.EMAIL_QUICKBOOK],
            groupKey: [MODULE_GROUP_CONSTANTS.EMAIL_VIEWER],
            checkOtherForVisibility: [],
            submenu: [],
          }
        ]
      },
      {
        path: '',
        title: 'MENUITEMS.CITY_MANAGER',
        iconType: 'feather',
        icon: 'map',
        class: 'menu-toggle',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_GROUP_CONSTANTS.CITY_MANAGER],
        groupKey: [MODULE_GROUP_CONSTANTS.CITY_MANAGER],
        checkOtherForVisibility: [],
        submenu: [
          {
            path: '/job-planning/calendar-view',
            title: 'MENUITEMS.CITY_MANAGER_SUB_MENU.CALENDAR_VIEW',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.JOB_LABOR_PLANNING],
            groupKey: [MODULE_GROUP_CONSTANTS.CITY_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/job-planning/check-in',
            title: 'MENUITEMS.CITY_MANAGER_SUB_MENU.CHECK_IN',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.JOB_LABOR_PLANNING],
            groupKey: [MODULE_GROUP_CONSTANTS.CITY_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/job-planning/daily-activity',
            title: 'MENUITEMS.CITY_MANAGER_SUB_MENU.DAILY_ACTIVITY',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.DAILY_ACTIVITY],
            groupKey: [MODULE_GROUP_CONSTANTS.CITY_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
           {
            path: '/job-planning/payroll-entry',
            title: 'MENUITEMS.CITY_MANAGER_SUB_MENU.PAYROLL_ENTRY',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.PAYROLL_ENTRY_ADD_UPDATE],
            groupKey: [MODULE_GROUP_CONSTANTS.CITY_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/job-planning/payroll-entry-report',
            title: 'MENUITEMS.CITY_MANAGER_SUB_MENU.PAYROLL_ENTRY_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.PAYROLL_ENTRY_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.CITY_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
           {
            path: '/job-planning/payroll-entry-snapshot',
            title: 'MENUITEMS.CITY_MANAGER_SUB_MENU.PAYROLL_ENTRY_SNAPSHOT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.PAYROLL_ENTRY_SNAPSHOT],
            groupKey: [MODULE_GROUP_CONSTANTS.CITY_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
           path: '/job-planning/manual-payroll-entry',
           title: 'MENUITEMS.CITY_MANAGER_SUB_MENU.MANUAL_PAYROLL_ENTRY',
           iconType: '',
           icon: '',
           class: 'ml-menu',
           groupTitle: false,
           badge: '',
           badgeClass: '',
           sidebarLeftIconVisible: true,
           display: false,
           moduleKey: [MODULE_CONSTANTS.MANUAL_PAYROLL_ENTRY],
           groupKey: [MODULE_GROUP_CONSTANTS.CITY_MANAGER],
           checkOtherForVisibility: [],
           submenu: [],
           },
           {
            path: '/job-planning/billing-entry',
            title: 'MENUITEMS.CITY_MANAGER_SUB_MENU.BILLING_ENTRY',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.BILLING_ENTRY_ADD_UPDATE],
            groupKey: [MODULE_GROUP_CONSTANTS.CITY_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/job-planning/billing-entry-report',
            title: 'MENUITEMS.CITY_MANAGER_SUB_MENU.BILLING_ENTRY_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.BILLING_ENTRY_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.CITY_MANAGER],
            checkOtherForVisibility: [],
            submenu: [],
          },
        ]
      },
      {
        path: '',
        title: 'MENUITEMS.SHOW_JOB_CENTRAL',
        iconType: 'feather',
        icon: 'book-open',
        class: 'menu-toggle',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_GROUP_CONSTANTS.SHOW_JOB_CENTRAL],
        groupKey: [MODULE_GROUP_CONSTANTS.SHOW_JOB_CENTRAL],
        checkOtherForVisibility: [],
        submenu: [
          {
            path: '/show-job-central/show-central',
            title: 'MENUITEMS.SHOW_JOB_CENTRAL_SUB_MENU.SHOW_CENTRAL',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.SHOW_CENTRAL],
            groupKey: [MODULE_GROUP_CONSTANTS.SHOW_JOB_CENTRAL],
            checkOtherForVisibility: [],
            submenu: [],
          },
        ]
      },
      {
        path: '/weekly-meet/doc-upload-list',
        title: 'MENUITEMS.WEEKLY_MEETING',
        iconType: 'feather',
        icon: 'clock',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_CONSTANTS.COMMON],
        groupKey: [MODULE_GROUP_CONSTANTS.COMMON],
        checkOtherForVisibility: [SIDEBAR_MENU_VISIBILITY_CHECK_CONSTANTS.WEEKLY_MEET],
        submenu: [

        ]
      },
      {
        path: '',
        title: 'MENUITEMS.LEADERSHIP_OPERATION',
        iconType: 'feather',
        icon: 'book-open',
        class: 'menu-toggle',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_GROUP_CONSTANTS.LEADERSHIP_OPERATION],
        groupKey: [MODULE_GROUP_CONSTANTS.LEADERSHIP_OPERATION],
        checkOtherForVisibility: [],
        submenu: [
          {
            path: '/leadership-operations/estimation-revenue-info',
            title: 'MENUITEMS.LEADERSHIP_OPERATION_SUB_MENU.ESTIMATION_REVENUE_INFO',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.LEADERSHIP_OP_ESTIMATION_REVENUE_INFORMATION],
            groupKey: [MODULE_GROUP_CONSTANTS.LEADERSHIP_OPERATION],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/leadership-operations/overrun-jobs-view',
            title: 'MENUITEMS.LEADERSHIP_OPERATION_SUB_MENU.OVERRUN_JOBS_VIEW',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.LEADERSHIP_OP_OVERRUN_JOB_VIEW],
            groupKey: [MODULE_GROUP_CONSTANTS.LEADERSHIP_OPERATION],
            checkOtherForVisibility: [],
            submenu: [],
          },
        ]
      },
      {
        path: '',
        title: 'MENUITEMS.LEADERSHIP_SALES',
        iconType: 'feather',
        icon: 'book-open',
        class: 'menu-toggle',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_GROUP_CONSTANTS.LEADERSHIP_SALES],
        groupKey: [MODULE_GROUP_CONSTANTS.LEADERSHIP_SALES],
        checkOtherForVisibility: [],
        submenu: [
          {
            path: '/leadership-sales/dashboard',
            title: 'MENUITEMS.LEADERSHIP_SALES_SUB_MENU.DASHBAORD',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.LEADERSHIP_SALES_DASHBOARD],
            groupKey: [MODULE_GROUP_CONSTANTS.LEADERSHIP_SALES],
            checkOtherForVisibility: [],
            submenu: [],
          }
        ]
      },
      {
        path: '',
        title: 'MENUITEMS.REPORT',
        iconType: 'feather',
        icon: 'book-open',
        class: 'menu-toggle',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        sidebarLeftIconVisible: true,
        display: true,
        moduleKey: [MODULE_GROUP_CONSTANTS.REPORT],
        groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
        checkOtherForVisibility: [],
        submenu: [
          {
            path: '/report/audit-report',
            title: 'MENUITEMS.REPORT_SUB_MENU.AUDIT_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.AUDIT_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/report/city-hours-report',
            title: 'MENUITEMS.REPORT_SUB_MENU.CITY_HOURS_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.CITY_HOURS_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
            checkOtherForVisibility: [],
            submenu: [],
          },
           {
            path: '/report/estimator-so-search-report',
            title: 'MENUITEMS.REPORT_SUB_MENU.ESTIMATOR_SO_SEARCH_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.ESTIMATOR_SO_SEARCH],
            groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/report/full-schedule-report',
            title: 'MENUITEMS.REPORT_SUB_MENU.FULL_SCHEDULE_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.FULL_SCHEDULE_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/report/job-update-report',
            title: 'MENUITEMS.REPORT_SUB_MENU.JOB_UPDATE_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.JOB_UPDATE_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/report/job-performance-report',
            title: 'MENUITEMS.REPORT_SUB_MENU.JOB_PERFORMANCE_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.JOB_PERFORMANCE_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/report/ranking-report',
            title: 'MENUITEMS.REPORT_SUB_MENU.RANKING_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.RANKING_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/report/show-specific-report',
            title: 'MENUITEMS.REPORT_SUB_MENU.SHOW_SPECIFIC_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.SHOW_SPECIFIC_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/report/show-comparison-report',
            title: 'MENUITEMS.REPORT_SUB_MENU.SHOW_COMPARISON_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.SHOW_COMPARISON_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/report/payroll-labor-hours-report',
            title: 'MENUITEMS.REPORT_SUB_MENU.PAYROLL_LABOR_HOURS_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.PAYROLL_LABOR_HOURS],
            groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
            checkOtherForVisibility: [],
            submenu: [],
          },
          {
            path: '/report/travel-lead-report',
            title: 'MENUITEMS.REPORT_SUB_MENU.TRAVEL_LEAD_REPORT',
            iconType: '',
            icon: '',
            class: 'ml-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            sidebarLeftIconVisible: true,
            display: false,
            moduleKey: [MODULE_CONSTANTS.TRAVEL_LEAD_REPORT],
            groupKey: [MODULE_GROUP_CONSTANTS.REPORT],
            checkOtherForVisibility: [],
            submenu: [],
          }
         ]
      },
    ]
  }
}
